import { sidebarNodeTypes } from '../../../config/config';
import { BaseApi } from '../../common/api/base-api.interface';
import { TextNodeCreateProps } from '../models/text-node-create-props';
import { getApiForNodeType } from './../../common/api/api-map';
import { createTextNode } from './create-text-node';
import { setupTextNode } from './setup-text-node';

export const textNodeAPI = (): BaseApi<TextNodeCreateProps> => ({
  name: sidebarNodeTypes.textNode,
  setup: setupTextNode,
  create: createTextNode,
  getCursor: () => 'text',
  ...getApiForNodeType(sidebarNodeTypes.textNode),
});
